import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50eb78bc")

_pushScopeId("data-v-50eb78bc")
const _hoisted_1 = { class: "user" }
const _hoisted_2 = { class: "control-bar" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "hint" }, "请在绑定账号时，选择Audiences-Manage(受众-管理)的权限", -1)
const _hoisted_4 = { class: "bind-btn" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 绑定账号 ")
const _hoisted_6 = { class: "list-wrap" }
const _hoisted_7 = {
  key: 0,
  class: "account-list"
}
const _hoisted_8 = { class: "account-item-wrap" }
const _hoisted_9 = { class: "account-info" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Partner ID : ")
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, "1.在criteo后台，选择 Events tracking 配置代码", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { style: {"margin-top":"6px"} }, "2.选择 Direct implementation 后获取跟踪ID", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "el-icon-question" }, null, -1)
const _hoisted_14 = { class: "account-editor" }
const _hoisted_15 = { class: "el-icon-loading" }
const _hoisted_16 = { class: "account-text-wrap" }
const _hoisted_17 = {
  key: 0,
  class: "account-warn"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 解除绑定 ")
const _hoisted_19 = { class: "pagination-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageHeader = _resolveComponent("PageHeader")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_MPagination = _resolveComponent("MPagination")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", null, [
      _createVNode(_component_PageHeader, { title: "商户管理" })
    ]),
    _createVNode("main", null, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "medium",
            onClick: _ctx.triggerBind,
            loading: _ctx.bindLoading,
            disabled: _ctx.loading
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ])
      ]),
      _withDirectives(_createVNode("div", _hoisted_6, [
        (_ctx.list.length)
          ? (_openBlock(), _createBlock("ul", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("li", {
                  key: item.id
                }, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("h1", null, _toDisplayString(item.criteo_name), 1),
                    _createVNode("div", _hoisted_9, [
                      _createVNode("span", null, [
                        _hoisted_10,
                        _createVNode(_component_el_tooltip, {
                          placement: "right",
                          effect: "light"
                        }, {
                          content: _withId(() => [
                            _hoisted_11,
                            _hoisted_12
                          ]),
                          default: _withId(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        })
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_14, [
                        _createVNode(_component_el_input, {
                          size: "mini",
                          onBlur: _ctx.editPxId,
                          ref: 
                      el => {
                        _ctx.editors[item.id] = el;
                      }
                    ,
                          modelValue: item.criteo_partner_id,
                          "onUpdate:modelValue": ($event: any) => (item.criteo_partner_id = $event),
                          disabled: item.editLoading
                        }, null, 8, ["onBlur", "modelValue", "onUpdate:modelValue", "disabled"]),
                        _withDirectives(_createVNode("i", _hoisted_15, null, 512), [
                          [_vShow, item.editLoading]
                        ])
                      ], 512), [
                        [_vShow, item.isEditor]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_16, [
                        _createVNode("span", null, _toDisplayString(item.criteo_partner_id), 1),
                        _createVNode("i", {
                          class: "el-icon-edit",
                          onClick: ($event: any) => (_ctx.showEditor(item))
                        }, null, 8, ["onClick"])
                      ], 512), [
                        [_vShow, !item.isEditor]
                      ])
                    ]),
                    (item.auth_error_message)
                      ? (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(item.auth_error_message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_button, {
                    size: "medium",
                    onClick: ($event: any) => (_ctx.triggerUnBind(item, index)),
                    loading: item.unBindLoading
                  }, {
                    default: _withId(() => [
                      _hoisted_18
                    ]),
                    _: 2
                  }, 1032, ["onClick", "loading"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              description: "没有任何数据"
            }))
      ], 512), [
        [_directive_loading, _ctx.loading]
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode(_component_MPagination, {
          total: _ctx.pagination.total,
          pageSize: _ctx.pagination.pageSize,
          onCurrentChange: _ctx.changePage
        }, null, 8, ["total", "pageSize", "onCurrentChange"])
      ])
    ])
  ]))
})